import AbstractCanvasTransformTool from "ui/canvas/transforms/AbstractCanvasTransformTool";
import {SCENE_FRAMES} from "ui/config";

/**
 * Transform layer: make blur for each frame
 */
export default class CanvasBlur extends AbstractCanvasTransformTool {
	/**
	 * @param {number} [radiusFrom]
	 * @param {number} [radiusTo]
	 */
	constructor(radiusFrom, radiusTo) {
		super();

		/**
		 * @type {number}
		 * @private
		 */
		this._radiusFrom = radiusFrom;

		/**
		 * @type {number}
		 * @private
		 */
		this._radiusTo = radiusTo;

		/**
		 * @type {number[]}
		 * @private
		 */
		this._radiusByFrames = [];
	}

	/**
	 * @inheritDoc
	 */
	_isNeedKeyframesForSelection(fromFrame, toFrame) {
		return fromFrame !== toFrame && this._radiusFrom !== this._radiusTo;
	}

	/**
	 * @inheritDoc
	 */
	async _prepare(layer, fromFrame, toFrame) {
		const len = toFrame - fromFrame;
		let radius, radiusStep;

		this._radiusByFrames = new Array(SCENE_FRAMES).fill(0);

		if (len === 0) {
			radiusStep = 0;
			radius = this._radiusFrom;
		} else if (this._radiusFrom === this._radiusTo) {
			radiusStep = 0;
			radius = this._radiusFrom;
		} else {
			radiusStep = (this._radiusTo - this._radiusFrom) / len;
			radius = this._radiusFrom;
		}

		for (let i = fromFrame; i <= toFrame; i++) {
			this._radiusByFrames[i] = radius;
			radius += radiusStep;
		}
	}

	/**
	 * @param {HTMLCanvasElement} canvas
	 * @param {CanvasRenderingContext2D} ctx
	 * @param {HTMLImageElement} img
	 * @param {number} frameIndex
	 * @returns {?T_DataSetItem}
	 * @protected
	 */
	_processImage(canvas, ctx, img, frameIndex) {
		if (this._radiusByFrames[frameIndex] === 0) {
			return null;
		}

		ctx.clearRect(0, 0, this._sceneWidth, this._sceneHeight);
		ctx.save();
		ctx.filter = `blur(${this._radiusByFrames[frameIndex]}px)`;
		ctx.drawImage(img, 0, 0);
		ctx.restore();
		return this._dataSet.setData(canvas.toDataURL('image/png'));
	}
}
